module.exports = __webpack_public_path__ + "static/media/Ecommerce-mobile.26e812a5.png";